import * as CONST from '../ActionTypes';

const initialState = {
  newsList: [],
  news: {},
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    search: '',
  },
  isSuccess: false,
};

function news(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // お知らせ一覧取得
    // -----------------
    case CONST.GET_NEWS_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          newsList: action.payload,
        },
      );
    case CONST.GET_NEWS_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          newsList: [],
        },
      );
    // -----------------
    // お知らせ詳細取得
    // -----------------
    case CONST.GET_NEWS_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          news: action.payload,
        },
      );
    case CONST.GET_NEWS_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          news: {},
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_NEWS_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: action.payload,
        },
      );
    // -----------------
    // お知らせ更新
    // -----------------
    case CONST.UPDATE_NEWS_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
        },
      );
    // -----------------
    // お知らせ削除
    // -----------------
    case CONST.DELETE_NEWS_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
        },
      );
    // -----------------
    // お知らせ削除
    // -----------------
    case CONST.CLEAR_NEWS_RESULT:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
        },
      );
    default:
      return state;
  }
}

export default news;
